import React from 'react'
import classes from './Form.scss'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'

const form = ({ form, inputChanged }) => {
  let input = Object.entries(form).map(item => {
    let [key, attr] = item

    return (
      <InputGroup
        key={key}
        label={attr.label}
        inputType={attr.elementType}
        configs={attr.elementConfig}
        invalid={!attr.valid}
        validations={attr.validation}
        touched={attr.touched}
        changed={e => inputChanged(key, e)}
        inputValue={attr.value}
        validationError={attr.error}
      />
    )
  })
  return <form className={classes.Form}>{input}</form>
}

export default form
